import NeuralSpinner from '../../ui/NeuralSpinner';

const SIZE_MAP = { sm: 'sm', md: 'md', lg: 'lg' };

const Spinner = ({ text, size = 'md', inline = false }) => {
  const spinnerSize = SIZE_MAP[size] ?? 'md';

  if (inline) {
    return (
      <span className="inline-flex items-center gap-2">
        <NeuralSpinner size={spinnerSize} />
        {text && <span>{text}</span>}
      </span>
    );
  }

  return (
    <div className="text-center text-slate-600 dark:text-slate-400 text-lg">
      <NeuralSpinner size={spinnerSize} className="mb-4 mx-auto" />
      {text || 'Cargando...'}
    </div>
  );
};

export default Spinner;
